/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalRegistrationDataDto
 */
export interface ExternalRegistrationDataDto {
    /**
     * 
     * @type {string}
     * @memberof ExternalRegistrationDataDto
     */
    url: string;
}

export function ExternalRegistrationDataDtoFromJSON(json: any): ExternalRegistrationDataDto {
    return ExternalRegistrationDataDtoFromJSONTyped(json, false);
}

export function ExternalRegistrationDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalRegistrationDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ExternalRegistrationDataDtoToJSON(value?: ExternalRegistrationDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

